import React from 'react'
import { connect } from 'react-redux'

import { receiptActions } from '../../core/receipt'

class AddItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isSplit: false,
      name: '',
      price: 0,
      split: 1
    }
  }

  _onChange (e) {
    const value = e.target.type === 'number' ? Number(e.target.value): e.target.value

    this.setState({[e.target.name]: value})
  }

  _onCheckboxChange (e) {
    const isSplit = !this.state.isSplit
    const split = isSplit ? this.state.split : 1 // return split to 1 when not isSplit

    this.setState({
      isSplit,
      split
    })
  }

  _onSubmit (e) {
    e.preventDefault()

    const { isSplit, name, price, split } = this.state
    const isActuallySplit = isSplit && split > 1

    this.props.onSubmit({
      isSplit: isActuallySplit,
      name,
      price,
      split
    })

    this.refs.name.value = ''
    this.refs.price.value = ''
    if (this.refs.split) {
      this.refs.split.value = ''
    }
    this.refs.name.focus() // focus on name after submit for usability

    this.setState({
      isSplit: false,
      name: '',
      price: 0,
      split: 1
    })
  }

  render () {
    const { isSplit } = this.state

    return (
      <form onSubmit={(e) => this._onSubmit(e)} className="dotted-bottom">
        <input type="text" name="name" ref="name" placeholder="Caesar Salad" className="item-input" onChange={(node) => this._onChange(node)} />
        <span> $ </span>
        <input type="number" name="price" step="0.001" ref="price" placeholder="9.25" className="item-input item-money-input" onChange={(node) => this._onChange(node)} />
        <br />
        <label>split?
          <input type="checkbox" name="isSplit" checked={this.state.isSplit} onChange={(node) => this._onCheckboxChange(node)} />
        </label>
        {isSplit && <span><input type="number" name="split" ref="split" placeholder="2" className="item-input" onChange={(node) => this._onChange(node)} /> ways</span>}
        <button type="submit" className="item-btn">Add</button>
      </form>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (item) => dispatch(receiptActions.addItem(item))
  }
}

export default connect(state => state, mapDispatchToProps)(AddItem)



/** WEBPACK FOOTER **
 ** ./src/views/containers/AddItem.js
 **/